import * as React from "react";
import { useSteps } from "../../../../hooks/hooks/use-steps.js";
import { ConfiguratorMain } from "./ConfiguratorMain.js";
const ConfiguratorMainContainer = (props) => {
  const { currentStepName } = useSteps();
  return /* @__PURE__ */ React.createElement(ConfiguratorMain, { currentStepName, ...props });
};
export {
  ConfiguratorMainContainer
};
//# sourceMappingURL=ConfiguratorMainContainer.js.map
